import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import gsap from 'gsap';
import Lottie from 'lottie-react';
import arowDownLottie from 'src/assets/arrow-down.json';
import { Button } from 'src/components/common/Button';
import Scroller from 'src/utils/scroller';

import { prayerDispatcher } from '../../prayer-dispatcher';
import css from './main-prayer-section.module.scss';

interface Props {
  prayerMainListRef: React.RefObject<HTMLDivElement>;
  prayerMainContainerRef: React.RefObject<HTMLDivElement>;
  confirmBtnRef: React.RefObject<HTMLButtonElement>;
  onConfirmBtnClick: () => void;
  prayer: string;
}

const PRAYER_SCREEN_SCROLLER_SUBJECT = 'prayerScreenScroller';

export const MainPrayerSection: React.FC<Props> = ({
  prayerMainListRef,
  prayerMainContainerRef,
  confirmBtnRef,
  onConfirmBtnClick,
  prayer = '',
}) => {
  return (
    <div ref={prayerMainContainerRef} className={css.mainPrayer}>
      <div ref={prayerMainListRef} className={css.mainPrayerList}>
        <p className={css.prayerText}>{prayer}</p>
      </div>

      <Button onClick={onConfirmBtnClick} ref={confirmBtnRef} className={cn(css.confirmPointsBtn)}>
        התפללתי בכוונה
      </Button>
    </div>
  );
};
